
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { Label } from "@/components/ui/label";

interface WorkArrangementFilterProps {
  workArrangementFilter: string;
  onWorkArrangementChange: (value: string) => void;
}

export function WorkArrangementFilter({
  workArrangementFilter,
  onWorkArrangementChange,
}: WorkArrangementFilterProps) {
  return (
    <div>
      <Label className="text-foreground">Work Arrangement</Label>
      <Select value={workArrangementFilter} onValueChange={onWorkArrangementChange}>
        <SelectTrigger className="bg-background border-border text-foreground rounded">
          <SelectValue placeholder="Select arrangement" className="text-muted-foreground" />
        </SelectTrigger>
        <SelectContent className="bg-card border-border rounded">
          <SelectItem value="all" className="text-foreground hover:bg-accent">All arrangements</SelectItem>
          <SelectItem value="Full time" className="text-foreground hover:bg-accent">Full time</SelectItem>
          <SelectItem value="Part time" className="text-foreground hover:bg-accent">Part time</SelectItem>
          <SelectItem value="Contract" className="text-foreground hover:bg-accent">Contract</SelectItem>
          <SelectItem value="Freelance" className="text-foreground hover:bg-accent">Freelance</SelectItem>
        </SelectContent>
      </Select>
    </div>
  );
}
